import { AccredibleOrganizationSettings } from '@accredible-frontend-v2/models';
import { AccredibleLanguageService } from '@accredible-frontend-v2/services/language';
import { Component } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  templateUrl: './header.component.html',
  styleUrls: [`./header.component.scss`],
})
export class HeaderComponent {
  organizationSettings$: Observable<AccredibleOrganizationSettings>;
  acmeHeaderLinks = [
    {
      id: 'rmi-certification',
      label: this._language.selectTranslate('employment_accredible_com.header.certification'),
      externalLink: 'https://credential.accredible.com',
    },
    {
      id: 'rmi-resources',
      label: this._language.selectTranslate('employment_accredible_com.header.resources'),
      externalLink: 'https://credential.accredible.com',
    },
    {
      id: 'rmi-programs',
      label: this._language.selectTranslate('employment_accredible_com.header.programs'),
      externalLink: 'https://credential.accredible.com',
    },
    {
      id: 'rmi-enroll',
      label: this._language.selectTranslate('employment_accredible_com.header.enroll'),
      externalLink: 'https://credential.accredible.com',
    },
  ];

  constructor(private readonly _language: AccredibleLanguageService) {}
}
